import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { parameters } from '@services/api'

export class parametersStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable filteredList = []
    @observable filters = {}

    @action
    getParametersList = async params => {
        this.loading = true
        const { data: list } = await parameters.getList({ ...params })
        runInAction(() => {
            this.list = list
            this.applyFilters()
        })
    }

    @action
    applyFilters = () => {
        const newList = this.list.filter(item => {
            let filter = true
            if ('name' in this.filters) {
                filter = item.name.includes(this.filters['name'])
            }
            if (filter && 'param_group_id' in this.filters) {
                filter =
                    item.param_group_id === this.filters['param_group_id'] ||
                    (!item.param_group_id && this.filters['param_group_id'] === 'EMPTY')
            }
            if (filter && 'relevant' in this.filters) {
                if (this.filters['relevant'] === 'RELEVANT') {
                    filter = !!item.value
                } else {
                    filter = !item.value
                }
            }
            return filter
        })
        runInAction(() => {
            this.filteredList = newList
            this.loading = false
        })
    }

    @action
    addFilter = (name, value) => {
        this.loading = true
        const newFilters = { ...this.filters }
        if (name in newFilters && !value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
            this.applyFilters()
        })
    }

    @action
    resetFilters = () => {
        this.filters = {}
        this.applyFilters()
    }

    @action
    resetParameters = () => {
        this.list = []
        this.filteredList = []
        this.filters = {}
    }
}

export default remotedev(new parametersStore())
